import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserFriendlyError } from '../../../model/Error'
import { questionnaireTemplatesKeys } from './questionnaireTemplates.keys'
import { deleteQuestionnaireTemplate } from '../../../data/questionnaireTemplates'

interface QuestionnaireTemplateMutateVariable {
  questionnaireTemplateId: number
}

export const useDeleteQuestionnaireTemplate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ questionnaireTemplateId }: QuestionnaireTemplateMutateVariable) => {
      const { ok } = await deleteQuestionnaireTemplate(questionnaireTemplateId)
      if (!ok) {
        throw new UserFriendlyError('error', 'La suppression du questionnaire a échoué')
      }
      return null
    },

    onSuccess: (_, { questionnaireTemplateId }) => {
      queryClient.invalidateQueries({ queryKey: questionnaireTemplatesKeys.lists })
      queryClient.removeQueries({
        queryKey: questionnaireTemplatesKeys.detail(questionnaireTemplateId),
      })
    },
  })
}
